import { useState } from "react";
import Transactions from "../Components/Transactions/Transactions";
import Included, { Custom } from "../Components/Included/Included";
import Nav from "../Components/Nav/Nav";
import Footer from "../Components/Footer/Footer";
import logo from "../Assets/Logo/lipana.svg"

const Pricing = () => {
  const [sticky, setSticky] = useState("#");

  if (typeof window !== "undefined") {
    window.addEventListener("scroll", () => {
      if (window.pageYOffset > 100) {
        return setSticky("sticky");
      } else {
        return setSticky("#");
      }
    });
  }
  return (
    <section>
      <div
        className={`z-50 w-full text-blackColor bg-[#f8f7f4] ${
          sticky === "sticky" ? `fixed top-0 w-full` : ``
        }`}
      >
        <Nav logo={logo}/>
      </div>
      <div className="mt-16 md:mb-32">
        <Transactions />
      </div>
      <Included />
      <Custom />
      <Footer />
    </section>
  );
};

export default Pricing;
